import React from 'react';

const ReturnOverride = (props) => (
    <svg
        width="20px"
        height="20px"
        viewBox="0 0 20 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        {...props}
    >
        <title>Icon/ReturnsOver b@1.5x</title>
        <g id="Gscope---Left-Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Gscope_icons" transform="translate(-386.000000, -1244.000000)" fill="#000000">
                <g id="Icon/OL-Copy-3" transform="translate(386.000000, 1244.000000)">
                    <path
                        d="M19.375,10 C19.75,10 20,10.375 20,10.625 C19.625,15.875 15.25,20 10,20 C6.375,20 3,18 1.25,14.875 L1.25,14.875 L1.25,18.125 C1.25,18.5 1,18.75 0.625,18.75 C0.25,18.75 0,18.5 0,18.125 L0,18.125 L0,13.125 C0,12.75 0.25,12.5 0.625,12.5 L0.625,12.5 L5.625,12.5 C6,12.5 6.25,12.75 6.25,13.125 C6.25,13.5 6,13.75 5.625,13.75 L5.625,13.75 L2.125,13.75 C3.5,16.75 6.625,18.75 10,18.75 C14.625,18.75 18.5,15.25 18.75,10.625 C18.75,10.25 19,10 19.375,10 Z M10,0 C13.625,0 17,2 18.75,5.125 L18.75,5.125 L18.75,1.875 C18.75,1.5 19,1.25 19.375,1.25 C19.75,1.25 20,1.5 20,1.875 L20,1.875 L20,6.875 C20,7.25 19.75,7.5 19.375,7.5 L19.375,7.5 L14.375,7.5 C14,7.5 13.75,7.25 13.75,6.875 C13.75,6.5 14,6.25 14.375,6.25 L14.375,6.25 L17.875,6.25 C16.5,3.25 13.375,1.25 10,1.25 C5.375,1.25 1.625,4.875 1.25,9.375 C1.25,9.75 1,10 0.625,10 C0.25,10 0,9.625 0,9.375 C0.375,4.125 4.75,0 10,0 Z"
                        id="🎨-Color"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
);

export default ReturnOverride;
